import createStore from '@/stores/createStore';
// tôi đang dùng zustand
export type TBodyScreenState = {
  keyBody?: string;
  setKeyBody: (keyBody?: string) => void;
  resetBodyScreenStore: () => void;
};

const initState = {
  keyBody: undefined,
};

const useBodyScreenStore = createStore<TBodyScreenState>((set) => ({
  ...initState,
  resetBodyScreenStore() {
    set((s) => ({ ...s, ...initState }));
  },
  setKeyBody(keyBody?: string) {
    set((s) => ({ ...s, keyBody }));
  },
}));

export default useBodyScreenStore;
